module.exports = __webpack_public_path__ + "img/cnd_Futuristic.2a77e410.svg";